












































































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import productModule from '@/store/module/ProductModule';
import ThingModel, {Fun, Property, Resource, ResourceType, StdThingModelAware} from "@/model/ThingModel";
import _ from "lodash";
import FunCreateDialog from './fun-create-dialog.vue'
import FunEditDialog from "@/view/device-manage/product/fun-edit-dialog.vue";
import {BoolSpec, DataType, EnumSpec, NumberSpec, TextSpec} from '@/module/thing/DataSpec';
import ierror from "tools-ts/src/error/InnerError";
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import {ResourceDeleteForm} from '@/form/TmodelForm';
import thingModelModule from "@/store/module/ThingModelModule";
import {Container} from "typescript-ioc";
import ThingModelApi from "@/module/thing/ThingModelApi";
import EditDialog from "@/component/Crud/edit-dialog.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import JsonEditor from "@/component/JsonEditor/index.vue";

@Component({
  components: {
    EditDialog,
    FunCreateDialog,
    FunEditDialog,
    DeleteDialog,
    RefreshButton,
    JsonEditor,
  },
})
export default class FunView extends Vue {

  @Ref()
  private createDialog!: FunCreateDialog

  @Ref()
  private editDialog!: FunEditDialog

  @Ref()
  private deleteDialog!: DeleteDialog

  @Ref()
  private tmodelDialog!: EditDialog

  private thingModelApi = Container.get(ThingModelApi)

  private loading = false

  private thingModelModule = thingModelModule

  private tmodel = new StdThingModelAware()

  private async editTmodel() {
    const tmodel = new ThingModel()
    tmodel.copy(this.tmodel)
    tmodel.productId = thingModelModule.thingModel.productId
    await this.thingModelApi.edit(tmodel)
  }

  private get activeResource() {
    return thingModelModule.resourceOrNull
        ?? new class extends Resource {
        }
  }

  private confirmDelete = async () => {
    const form = new ResourceDeleteForm(
        productModule.active.id,
        this.activeResource
    )
    await this.thingModelApi.resourceDelete(form)
  }

  private async created() {
    await this.queryThingModel()
  }

  private destroyed() {
    thingModelModule.destroy()
  }

  private async queryThingModel() {
    this.loading = true
    await thingModelModule.activate(productModule.active.id)
    this.tmodel = new StdThingModelAware()
    this.tmodel.copy(thingModelModule.thingModel)
    this.loading = false
  }

  private async changeActiveResource(resource: Resource) {
    await thingModelModule.activateResource(resource)
  }

  private resourceTypeFmt(row: Resource): string {
    return this.$translate(_.camelCase(row.resourceType))
  }

  private funIdFmt(row: Fun): number {
    return row.funId
  }

  private dataTypeFmt(row: Property): string {
    return _.camelCase(row.dataType)
  }

  private dataSpecsFmt(row: Resource | undefined): string {
    if (row == undefined || row.resourceType != ResourceType.PROPERTY) return ""

    const prop = row as Property
    switch (prop.dataType) {
      case DataType.ENUM:
        return this.formatEnumSpec(prop.dataSpecs as Array<EnumSpec>)
      case DataType.BOOL:
        return this.formatBoolSpec(prop.dataSpecs as Array<BoolSpec>)
      case DataType.TEXT:
        return this.formatTextSpec(prop.dataSpecs[0] as TextSpec)
      case DataType.INT:
      case DataType.FLOAT:
      case DataType.DOUBLE:
        return this.formatNumberSpec(prop.dataSpecs[0] as NumberSpec)
    }

    ierror(`Unhandle dataType '${prop.dataType}' in Property '${JSON.stringify(prop)}'`)
    return ""
  }

  private formatEnumSpec(specs: Array<EnumSpec>): string {
    return _.flatMap(specs, spec => {
      return `${spec.name} ${spec.value}`
    }).join(" | \n")
  }

  private formatBoolSpec(specs: Array<BoolSpec>): string {
    return _.flatMap(specs, spec => {
      return `${spec.name} ${spec.value}`
    }).join(" | \n")
  }

  private formatTextSpec(spec: TextSpec): string {
    return `${this.$translate('length')} ${spec.length}`
  }

  private formatNumberSpec(spec: NumberSpec): string {
    let str = `
                ${this.$translate('min')} ${spec.min} | \n
                ${this.$translate('max')} ${spec.max} | \n
                ${this.$translate('step')} ${spec.step}
            `
    if (spec.unit?.symbol)
      str = str + ` | \n ${this.$translate('unit')} ${spec.unit?.symbol} \n`

    return str
  }

  private async openEditDialog(row: Resource) {
    await this.changeActiveResource(row)
    this.tmodel = new StdThingModelAware()
    this.tmodel.copy(thingModelModule.thingModel)
    this.editDialog.open()
  }

  private resourceTypeColor(resourceType: ResourceType) {
    switch (resourceType) {
      case ResourceType.PROPERTY:
        return '#1890FF'
      case ResourceType.EVENT:
        return '#1EA21D'
      case ResourceType.SERVICE:
        return '#FB8B24'
    }
  }
}
